import React from 'react'
import { cn } from '@/lib/utils'

export function PageHeader({
  title,
  description,
  actions,
  toolbar,
  className,
  children,
}) {
  const hasToolbar = !!toolbar
  const hasActions = !hasToolbar && (actions || children)

  return (
    <div className={cn("mb-6", className)}>
      <div className={hasActions ? "flex flex-col gap-4 md:flex-row md:items-center md:justify-between" : undefined}>
        <div>
          <h1
            className={cn(
              "font-semibold tracking-tight text-foreground",
              hasToolbar ? "text-xl" : "text-2xl"
            )}
          >
            {title}
          </h1>
          {description && (
            <p className="text-sm text-muted-foreground mt-1">{description}</p>
          )}
        </div>
        {hasActions && (
          <div className="flex items-center gap-2">
            {actions}
            {children}
          </div>
        )}
      </div>
      {hasToolbar && (
        <div className="flex flex-col md:flex-row md:items-center gap-2 mt-4">
          {toolbar}
        </div>
      )}
    </div>
  )
}

export default PageHeader
